module.exports = __webpack_public_path__ + "img/down-gd3.e0e4751b.png";